<template>
  <div  v-if="group.msg_group_id" >
    <div class="messages" id="messages" style="height:400px;">
      <div class="message" v-for="m in messages" :key="m.message_id"  v-bind:class="{ messagePersonal: (m.from_id==localuid && m.from_type=='user') }" >
        <figure v-if="(m.from_id!=localuid || m.from_type!='user')" class="avatar"><img src=""></figure>
        <span v-if="(m.from_id!=localuid || m.from_type!='user')" class="messageFromName">{{m.fromName}}</span>
        <span v-if="m.typing">&nbsp;</span>
        <span v-if="!m.typing"> {{ m.text }} </span>
      </div>
    </div>
    <div class="message-box">
      <textarea class="message-input" type="text" placeholder="Type message..." v-model="message" @keyup="catchEnter"></textarea>
      <button class="message-submit" type="submit" @click="sendMessage"> Send </button>
    </div>
  </div>
</template>

<script >
 
const scrollToBottom = function () {
        let messages = document.getElementById('messages');
        messages.scrollTop = messages.scrollHeight;
        setTimeout(() => {
            messages.scrollTop = messages.scrollHeight;
        }, 400);
}

import ChatCommon from '../mixins/chatcommon';

export default {
  mixins: [ChatCommon],
  props: [
    'localuid',
    'group'
  ],
  components: {

  },
  computed: {
    messages: {
      get() {
        let self = this;
        return this.$store.state.messages.filter(function(msg) {
           if (msg.msg_group_id == self.group.msg_group_id) {
             if (msg.text != '') {
               return true;
             }
           }
           return false;
        })
      }
    }
  },
  data () {
    return {
      message: '',
      chat_scroll_toggle: false,
      isPersonal: true,
    }
  },
  methods: {
    
    catchEnter: function(e) {
      if (e.keyCode == 13)
      {
        if (e.shiftKey === true) { return true; }
        else { this.sendMessage(); }
        return false;
      }
    },
    sendMessage: function() {
      if (this.message.trim()=='') { return; }
      this.$store.dispatch('messageAdd', {  msg_group_id: this.group.msg_group_id, 
                                            text: this.message,
                                        });
      this.message='';
      //var objDiv = document.getElementById('#messsages');
      //let objDiv = this.find('#messages');
      //console.log(objDiv);
      //objDiv.scrollTop = objDiv.scrollHeight;
      scrollToBottom();
    },
    printMessagesCursor: function() {
    },
  },
  watch: {
    messages: function() {
      scrollToBottom();
    }
  },
  mounted() {
    this.$store.dispatch('setReadAllMessagesInGroup', this.group.msg_group_id);
    scrollToBottom();
  }
}
</script>


<style lang='scss' scoped>

/*--------------------
Mixins
--------------------*/
@mixin center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@mixin ball {
  @include center;
  content: '';
  display: block;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: rgba(255, 255, 255, .5);
  z-index: 2;
  margin-top: 4px;
  animation: ball .45s cubic-bezier(0, 0, 0.15, 1) alternate infinite;
}


/*--------------------
Messages
--------------------*/
.messages {
  flex: 1 1 auto;
  color: black;
  background:linear-gradient(120deg, #FAF2E3, whitesmoke);
  overflow-y: scroll;
  position: relative;
  width: 100%;
  padding: 0 10px 0px 0px;

  .message {
    clear: both;
    float: left;
    padding: 6px 10px 7px;
    border-radius: 10px 10px 10px 0;
    background: white;
    margin: 8px 12px;
    margin-left: 35px;
    position: relative;
    text-shadow: 0 1px 1px rgba(0, 0, 0, .2);

    .timestamp {
      position: absolute;
      bottom: -15px;
      font-size: 12px;
      color: rgba(255, 255, 255, .3);
    }

    .messageFromName {
      color: orange;
      display: block;
      font-size: 12px;
    }

    &::before {
      content: '';
      position: absolute;
      bottom: -6px;
      border-top: 6px solid rgba(0, 0, 0, .3);
      left: 0;
      border-right: 7px solid transparent;
    }

    .avatar {
      position: absolute;
      z-index: 1;
      bottom: -15px;
      left: -35px;
      border-radius: 30px;
      width: 30px;
      height: 30px;
      overflow: hidden;
      margin: 0;
      padding: 0;
      border: 2px solid rgba(255, 255, 255, 0.24);

      img {
        width: 100%;
        height: auto;
      }
    }

    &.messagePersonal {
      float: right;
      color: #fff;
      text-align: right;
      background: linear-gradient(120deg, #248A52, #257287);
      border-radius: 10px 10px 0 10px;

      &::before {
        left: auto;
        right: 0;
        border-right: none;
        border-left: 5px solid transparent;
        border-top: 4px solid #257287;
        bottom: -4px;
      }
    }

    &:last-child {
      margin-bottom: 30px;
    }

    &.new {
      transform: scale(0);
      transform-origin: 0 0;
      animation: bounce 500ms linear both;
    }

    &.loading {

      &::before {
        @include ball;
        border: none;
        animation-delay: .15s;
      }

      & span {
        display: block;
        font-size: 0;
        width: 20px;
        height: 10px;
        position: relative;

        &::before {
          @include ball;
          margin-left: -7px;
        }

        &::after {
          @include ball;
          margin-left: 7px;
          animation-delay: .3s;
        }
      }
    }

  }
}



/*--------------------
Message Box
--------------------*/
.message-box {
  flex: 0 1 40px;
  width: 100%;
  height: 100px;
  background: white;
  padding: 10px;
  position: relative;

  & .message-input {
    background: none;
    border: none;
    outline: none!important;
    resize: none;
    color: black;
    margin: 0;
    padding-right: 20px;
    width: 80%;
  }

  textarea:focus:-webkit-placeholder{
      color: transparent;
  }

  & .message-submit {
    position: absolute;
    z-index: 1;
    top: 0px;
    right: 0px;
    color: #fff;
    border: none;
    background: #248A52;
    text-transform: uppercase;
    line-height: 1;
    padding: 6px 10px;
    outline: none!important;
    transition: background .2s ease;
    width: 100px;
    height: 100%;

    &:hover {
      background: #1D7745;
    }
  }
}


/*--------------------
Custom Srollbar
--------------------*/
.mCSB_scrollTools {
  margin: 1px -3px 1px 0;
  opacity: 0;
}

.mCSB_inside > .mCSB_container {
  margin-right: 0px;
  padding: 0 10px;
}

.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  background-color: rgba(0, 0, 0, 0.5)!important;
}



</style>
